import { useState } from 'react';
import { Button } from '@/shared/components';
import type { DamageSeverity } from '@/shared/api';
import { DAMAGE_SEVERITY_LABEL } from '../cleaningLabels';

export interface DamageReportInput {
  title: string;
  description: string;
  severity: DamageSeverity;
  estimatedCost: number | null;
}

/** Text-Report-Formular für Schäden (Live-Foto-Capture je Reiter kommt in B3). */
export function ReportDamageForm({
  onReport,
  isPending,
}: {
  onReport: (body: DamageReportInput) => void;
  isPending: boolean;
}) {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [severity, setSeverity] = useState<DamageSeverity>('Minor');
  const [estimatedCost, setEstimatedCost] = useState('');

  const submit = () => {
    onReport({
      title: title.trim(),
      description: description.trim(),
      severity,
      estimatedCost: estimatedCost ? Number(estimatedCost) : null,
    });
    setTitle('');
    setDescription('');
    setEstimatedCost('');
    setSeverity('Minor');
  };

  return (
    <div className="border-line/50 space-y-2 border-t pt-3 text-sm">
      <span className="text-ink-soft block text-xs uppercase tracking-wider">Schaden melden</span>
      <input
        type="text"
        placeholder="Titel (z.B. Tisch beschädigt)"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        className="border-line w-full rounded border px-3 py-2"
      />
      <textarea
        placeholder="Beschreibung"
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        rows={2}
        className="border-line w-full rounded border px-3 py-2"
      />
      <div className="flex gap-2">
        <select
          value={severity}
          onChange={(e) => setSeverity(e.target.value as DamageSeverity)}
          className="border-line rounded border px-2 py-1"
        >
          <option value="Minor">{DAMAGE_SEVERITY_LABEL.Minor}</option>
          <option value="Major">{DAMAGE_SEVERITY_LABEL.Major}</option>
          <option value="Critical">{DAMAGE_SEVERITY_LABEL.Critical}</option>
        </select>
        <input
          type="number"
          step="0.01"
          placeholder="Geschätzte Kosten EUR"
          value={estimatedCost}
          onChange={(e) => setEstimatedCost(e.target.value)}
          className="border-line flex-1 rounded border px-2 py-1"
        />
      </div>
      <div className="flex justify-end">
        <Button
          variant="brand"
          size="sm"
          loading={isPending}
          disabled={!title.trim() || !description.trim()}
          onClick={submit}
        >
          Schaden melden
        </Button>
      </div>
    </div>
  );
}
